import { useLayers } from '@ais-ui/react-openlayers';
import { useMemo } from 'react';

export const useGpsLostLayerStatus = () => {
  const { getLayersByIdContaining } = useLayers();

  const anyGpsLostLayers = useMemo(() => {
    const gpsLostLayers = getLayersByIdContaining('gps_lost_grid_');
    return gpsLostLayers.length > 0;
  }, [getLayersByIdContaining]);

  return {
    anyGpsLostLayers,
  };
};
